const NEW_WINDOW_MS = 30 * 24 * 60 * 60 * 1000;

export function isNew(createdAt?: string): boolean {
  if (!createdAt) return false;
  return Date.now() - new Date(createdAt).getTime() <= NEW_WINDOW_MS;
}
